import React from 'react';
import '../Styles/StarRating.css';

const StarRating = ({ count = 5 }) => {
  return (
    <div className="star-rating">
      {Array.from({ length: count }).map((_, index) => (
        <span key={index} className="star">&#9733;</span> // Unicode star
      ))}
    </div>
  );
};

export default StarRating;
